const about = {
  hero: {
    eyebrow: "Who we are",
    title:   "Trusted partner in",
    titleEm: "Dubai real estate",
  },
  team: {
    eyebrow: "Meet the experts",
    title:   "Our",
    titleEm: "team",
    sub:     "Meet the experts behind our success: dedicated, experienced, and ready to help you achieve your real estate goals.",
    role:    "Sales Officer",
  },
  body: {
    p1: "ProNet Real Estate is a Dubai-based agency specialising in residential and commercial properties across the UAE. With over 12 years of market experience, we help buyers, sellers, landlords, and tenants navigate the ever-evolving Dubai property landscape with confidence.",
    p2: "Our team of certified agents has deep knowledge of key Dubai communities including Downtown, Business Bay, Palm Jumeirah, Sobha Hartland, and more — as well as growing markets in Abu Dhabi, Sharjah, and Ajman.",
    p3: "We believe that buying or renting a home should be a smooth, transparent experience. That's why we provide end-to-end support: from your first property search to final handover and beyond.",
  },
  values: [
    { title: "Transparency",  desc: "No hidden fees. No pressure. Just honest guidance at every step." },
    { title: "Expertise",     desc: "12+ years in the UAE market. We know what communities deliver value." },
    { title: "Client first",  desc: "Your goals drive every recommendation we make." },
    { title: "Full service",  desc: "From search to conveyancing — we handle the entire journey." },
  ],
  cta: {
    title:   "Let's find your",
    titleEm: "property",
    sub:     "Reach out — our team is ready to help, 7 days a week.",
    send:    "Send a message",
  },
};

export default about;
